export const TOKENS = {
  AUTH_TOKEN_SESSION_KEY: 'A_T',
  TV_MODE_TOKEN: 'TvModeToken',
  ACCESS_TOKEN_EXPIRATION: 'A_T_E',
  IDLE_TIMEOUT_TOKEN: 'I_T_T',
  ACTIVITY_DATA: 'CYNET_A_D',
  LAST_REFRESH_CALL_TIMESTAMP: 'L_R_C',
  IS_SITE_CONTAINER_ROUTE: 'CYNET_I_S_C_R'
};

export const HOME_ROUTES = {
  global: '/SitePages/GlobalManage/Alerts',
  local: '/SitePages/dashboard',
  singleSite: '/SitePages/Home',
  msspSite: '/SitePages/GlobalManage/Alerts',
  alerts: '/SitePages/Alerts',
  tv: '/SitePages/tv'
};

export const LOGIN_ROUTES = {
  LOGIN: '/SitePages/login',
  PHONE_VERIFICATION: '/SitePages/phone',
  QR_VERIFICATION: '/SitePages/qr',
  FORGOT_PASSWORD: '/SitePages/forgot',
  RESET_PASSWORD: '/SitePages/reset',
  PASSWORD_EXPIRED: '/SitePages/expired',
  REGISTER: '/SitePages/register',
  LOGIN_WITH_COOKIE: '/SitePages/login-with-cookie'
};

export const USER_MESSAGES = {
  REQUIRED: 'This field is required',
  INVALID_EMAIL: 'Invalid e-mail address',
  INVALID_PINCODE: 'Invalid pin code',
  INVALID_PASSWORD: 'Invalid password',
  RESET_SUCCESSFUL: 'Your password was changed successfully',
  REGISTER_SUCCESSFUL: 'Registration completed successfully',
  REQUEST_SUCCESSFUL: 'Your request was sent successfully',
  RESET_LINK_REQUEST_FAILED: 'Failed to send link. Please try again or contact Cynet Support',
  RESET_LINK_REQUEST_SUCCESSFUL: 'A link was sent to your mail'
};

export const CONTACT_TYPES = {
  UNKNOWN: 0,
  SMS: 1,
  VOICE_CALL: 2,
  EMAIL: 3
};

export const MFA_SESSION_KEYS = {
  PHONE_EMAIL_STATE: 'mfaState',
  QR_STATE: 'mfaQrState'
};

export const EULA_LINK = 'https://www.cynet.com/eula-console';
